import * as z from "zod/v4";

export const OMSMetricsRequestSchema = z.object({
  startDate: z.date(),
  endDate: z.date(),
  merchantTimezone: z.string().optional(),
});

export const OMSMetricsResponseSchema = z.object({ value: z.number() });

const CarrierShipmentCountSchema_ = z.object({
  carrier: z.string(),
  count: z.number(),
});
export const CarrierShipmentCountSchema: z.ZodType<CarrierShipmentCount> =
  CarrierShipmentCountSchema_;
export interface CarrierShipmentCount
  extends z.infer<typeof CarrierShipmentCountSchema_> {}

export const ShipmentsByCarrierResponseSchema = z.object({
  carriers: z.array(CarrierShipmentCountSchema),
});

export const timeGrain = ["daily", "weekly", "monthly"] as const;
export type TimeGrain = (typeof timeGrain)[number];
export const TimeGrainSchema = z.enum(timeGrain);

export const CarrierVolumeOverTimeRequestSchema = z.object({
  startDate: z.date(),
  endDate: z.date(),
  grain: TimeGrainSchema,
  merchantTimezone: z.string().optional(),
});

const CarrierVolumeByPeriodSchema_ = z.object({
  period: z.string(),
  carriers: z.array(CarrierShipmentCountSchema),
});
export const CarrierVolumeByPeriodSchema: z.ZodType<CarrierVolumeByPeriod> =
  CarrierVolumeByPeriodSchema_;
export interface CarrierVolumeByPeriod
  extends z.infer<typeof CarrierVolumeByPeriodSchema_> {}

export const CarrierVolumeOverTimeResponseSchema = z.object({
  data: z.array(CarrierVolumeByPeriodSchema),
});

const FulfillmentCountByDateSchema_ = z.object({
  date: z.string(),
  count: z.number(),
});
export const FulfillmentCountByDateSchema: z.ZodType<FulfillmentCountByDate> =
  FulfillmentCountByDateSchema_;
export interface FulfillmentCountByDate
  extends z.infer<typeof FulfillmentCountByDateSchema_> {}

export const FulfillmentsOverTimeRequestSchema = z.object({
  startDate: z.date(),
  endDate: z.date(),
  grain: TimeGrainSchema,
  merchantTimezone: z.string().optional(),
});

export const FulfillmentsOverTimeResponseSchema = z.object({
  data: z.array(FulfillmentCountByDateSchema),
});

const DateValueSchema_ = z.object({
  date: z.string(),
  value: z.number(),
});
export const DateValueSchema: z.ZodType<DateValue> = DateValueSchema_;
export interface DateValue extends z.infer<typeof DateValueSchema_> {}

export const AvgDaysToFulfillOverTimeRequestSchema = z.object({
  startDate: z.date(),
  endDate: z.date(),
  grain: TimeGrainSchema,
  merchantTimezone: z.string().optional(),
});

export const AvgDaysToFulfillOverTimeResponseSchema = z.object({
  data: z.array(DateValueSchema),
});
